(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _sharemail = __webpack_require__(1);
	
	var _sharemail2 = _interopRequireDefault(_sharemail);
	
	var _sharelinks = __webpack_require__(2);
	
	var _teInteresa = __webpack_require__(4);
	
	var _teInteresa2 = _interopRequireDefault(_teInteresa);
	
	var _gigya = __webpack_require__(3);
	
	var _gigya2 = _interopRequireDefault(_gigya);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Logger.debug('script article loaded');
	
	/** get main vars */
	var app = Voonto.getInstance();
	
	// Inicializar gigya comments
	(0, _gigya2.default)();
	
	(0, _sharelinks.shareMeta)();
	
	var sharemail = null;
	$('.compartir-email').on('click', function () {
	    if (sharemail === null) {
	        sharemail = new _sharemail2.default('.capa-compartir-email');
	        sharemail.bind();
	    }
	    sharemail.toggle();
	});
	
	Voonto.$('[data-voc-vam]').on('vam:isempty', function () {
	    Logger.info('[VAM] Ad slot is empty, hide parent');
	    Voonto.$(this).parent().hide();
	});
	
	/** sticky teInteresa|ads */
	if (Voonto.is.mobile() || Voonto.is.tablet()) {
	    var $stickyAds = Voonto.$('.publi-sticky');
	    $stickyAds.find('[data-voc-vam]').on('vam:isempty', function () {
	        Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is empty');
	        var $urgente = Voonto.$('.urgente-teinteresa');
	        var showTeInteresa = true;
	        if ($urgente.length > 0) {
	            var $cerrarUrgente = $urgente.find('.cerrar');
	            var type = $cerrarUrgente.data('type');
	            if (type === 'urgente') {
	                if (compruebaCookie()) {
	                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	                } else {
	                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	                    showTeInteresa = false;
	                }
	            } else {
	                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	                showTeInteresa = false;
	            }
	        }
	
	        if (!showTeInteresa) {
	            Logger.info('BreakingNews ad slot is empty but exist urgente');
	            $stickyAds.hide();
	        } else {
	            Logger.info('BreakingNews ad slot is empty');
	            $stickyAds.hide();
	            var teinteresa = new _teInteresa2.default();
	            teinteresa.load(Voonto.$('#breaking-news-container'));
	        }
	    });
	
	    $stickyAds.find('[data-voc-vam]').on('vam:inactive', function () {
	        Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is inactive');
	        var $urgente = Voonto.$('.urgente-teinteresa');
	        var showTeInteresa = true;
	        if ($urgente.length > 0) {
	            var $cerrarUrgente = $urgente.find('.cerrar');
	            var type = $cerrarUrgente.data('type');
	            if (type === 'urgente') {
	                if (compruebaCookie()) {
	                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	                } else {
	                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	                    showTeInteresa = false;
	                }
	            } else {
	                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	                showTeInteresa = false;
	            }
	        }
	
	        if (!showTeInteresa) {
	            Logger.info('BreakingNews ad slot is inactive but exist urgente');
	            $stickyAds.hide();
	        } else {
	            Logger.info('BreakingNews ad slot is inactive');
	            $stickyAds.hide();
	            var teinteresa = new _teInteresa2.default();
	            teinteresa.load(Voonto.$('#breaking-news-container'));
	        }
	    });
	
	    $stickyAds.find('[data-voc-vam]').on('vam:slotrendered', function () {
	        var $urgente = Voonto.$('.urgente-teinteresa');
	        var showTeInteresa = true;
	        if ($urgente.length > 0) {
	            var $cerrarUrgente = $urgente.find('.cerrar');
	            var type = $cerrarUrgente.data('type');
	            if (type === 'urgente') {
	                if (compruebaCookie()) {
	                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	                } else {
	                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	                    showTeInteresa = false;
	                }
	            } else {
	                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	                showTeInteresa = false;
	            }
	        }
	
	        if (!showTeInteresa) {
	            Logger.info('[data-voc-vam][Breaking News] ad slot is active but exist urgente');
	            $stickyAds.hide();
	        } else {
	            Logger.info('[data-voc-vam][Breaking News] ad slot is active');
	            $stickyAds.show();
	        }
	    });
	
	    $stickyAds.on('click', function () {
	        Voonto.$(this).hide();
	    });
	
	    // Comportamiento para cerrar el menu de compartir cuando se hace scroll
	    var inputShareLayer = Voonto.$('input#capa_compartir'),
	        labelShareLayer = Voonto.$('label[for="capa_compartir"]'),
	        inputFixedLayer = Voonto.$('input#capa_compartir_fija'),
	        labelFixedLayer = Voonto.$('label[for="capa_compartir_fija"]'),
	        containerShareLayer = Voonto.$('aside.herramientas:not(.fija) .mas-compartir'),
	        containerShareFixedLayer = Voonto.$('aside.herramientas.fija .mas-compartir');
	
	    var closeShareLayerHandler = function closeShareLayerHandler() {
	        Logger.info('[CloseShareLayerHandler] scrolled');
	
	        if (inputShareLayer.prop('checked') === true) {
	            inputShareLayer.prop('checked', false);
	            Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
	        }
	
	        Voonto.$(window).unbind('scroll', undefined);
	        Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	    };
	
	    var closeFixedShareLayerHandler = function closeFixedShareLayerHandler() {
	        Logger.info('[CloseFixedShareLayerHandler] scrolled');
	
	        if (inputFixedLayer.prop('checked') === true) {
	            inputFixedLayer.prop('checked', false);
	            Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
	        }
	
	        Voonto.$(window).unbind('scroll', undefined);
	        Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	    };
	
	    var closeClickDocumentShareLayerHandler = function closeClickDocumentShareLayerHandler(e) {
	        Logger.info('[CloseShareLayerHandler] document onclick');
	
	        if (inputShareLayer.prop('checked') === true) {
	            // esta abierto el menu compartir
	            if (Voonto.$.contains(containerShareLayer.get(0), e.target) === false && Voonto.$.contains(labelShareLayer.get(0), e.target) === false) {
	                inputShareLayer.prop('checked', false);
	                Voonto.$(document).unbind('click', undefined);
	                Voonto.$(window).unbind('scroll', closeShareLayerHandler);
	                Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
	            }
	        }
	
	        if (inputFixedLayer.prop('checked') === true) {
	            // esta abierto el menu compartir de la barra fija
	            if (Voonto.$.contains(containerShareFixedLayer.get(0), e.target) === false && Voonto.$.contains(labelFixedLayer.get(0), e.target) === false) {
	                inputFixedLayer.prop('checked', false);
	                Voonto.$(document).unbind('click', undefined);
	                Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
	                Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
	            }
	        }
	    };
	
	    inputShareLayer.on('change', function () {
	        var $this = Voonto.$(this);
	        Logger.info('[CloseShareLayerHandler] input change');
	        if ($this.prop('checked') === true) {
	            Voonto.$(window).one('scroll', closeShareLayerHandler);
	            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler).on('click', closeClickDocumentShareLayerHandler);
	        } else {
	            Voonto.$(window).unbind('scroll', closeShareLayerHandler);
	            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	        }
	    });
	
	    inputFixedLayer.on('change', function () {
	        var $this = Voonto.$(this);
	        Logger.info('[CloseFixedShareLayerHandler] input change');
	        if ($this.prop('checked') === true) {
	            Voonto.$(window).one('scroll', closeFixedShareLayerHandler);
	            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler).on('click', closeClickDocumentShareLayerHandler);
	        } else {
	            Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
	            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	        }
	    });
	}
	
	function compruebaCookie() {
	    Logger.info('[Breaking News] compruebaCookieWebPush');
	    var src = 'BreakingNews-ABC';
	    Logger.info('[Breaking News] src: ' + src);
	    return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MSG_SUBMIT_ERROR = 'No se ha podido compartir.';
	var MSG_SUBMIT_OK = 'Email enviado correctamente.';
	var MSG_NAME_ERROR = 'El nombre debe ser de al menos tres caracteres';
	var MSG_SENDER_ERROR = 'Tu email debe tener un formato correcto';
	var MSG_RECIPIENT_ERROR = 'Su email debe tener un formato correcto';
	var MSG_CAPTCHA_ERROR = 'Debes rellenar el captcha';
	var $ = Voonto.$;
	
	var Sharemail = function () {
	  function Sharemail(selector) {
	    _classCallCheck(this, Sharemail);
	
	    this.$form = $(selector);
	    this.$button = this.$form.find('.boton-form');
	    this.sended = false;
	  }
	
	  _createClass(Sharemail, [{
	    key: 'validaEmail',
	    value: function validaEmail(email) {
	      var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	      return re.test(email);
	    }
	  }, {
	    key: 'validaForm',
	    value: function validaForm(nombre, tu_email, su_email, recaptcha) {
	      var valid = true;
	
	      var $errName = this.$form.find(".nombre").empty();
	      var $errSender = this.$form.find(".tu_email").empty();
	      var $errRecipient = this.$form.find(".su_email").empty();
	      var $errCaptcha = this.$form.find(".captcha").empty();
	
	      if (nombre.length <= 2) {
	        $errName.text(MSG_NAME_ERROR);
	        valid = false;
	      }
	
	      if (!this.validaEmail(tu_email)) {
	        $errSender.text(MSG_SENDER_ERROR);
	        valid = false;
	      }
	
	      if (!this.validaEmail(su_email)) {
	        $errRecipient.text(MSG_RECIPIENT_ERROR);
	        valid = false;
	      }
	
	      if (recaptcha.length === 0) {
	        $errCaptcha.text(MSG_CAPTCHA_ERROR);
	        valid = false;
	      }
	
	      return valid;
	    }
	  }, {
	    key: 'handleOnsubmit',
	    value: function handleOnsubmit() {
	      if (this.sended) {
	        return false;
	      }
	      var $msgSubmit = this.$form.find('.enviaremailmsg').empty();
	      var nombre = this.$form.find('#tu_nombre').val();
	      var tu_email = this.$form.find('#tu_email').val();
	      var su_email = this.$form.find('#su_email').val();
	      var captcha = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';
	
	      //Comprobamos que todos los estén rellenos
	      if (this.validaForm(nombre, tu_email, su_email, captcha)) {
	        var postData = {
	          'sender': tu_email,
	          'senderName': nombre,
	          'recipient': su_email,
	          'captcha': captcha,
	          'url': window.location.protocol + '//' + window.location.host + window.location.pathname
	        };
	
	        Logger.info('send ajax request', postData);
	        this.$button.removeClass('btn-azul').addClass('btn-gris');
	        this.sended = true;
	        $.ajax({
	          type: 'post',
	          url: "/ajax/v2/sharemail.html",
	          data: postData,
	          timeout: 20000
	        }).fail(function () {
	          this.sended = false;
	          $msgSubmit.text(MSG_SUBMIT_ERROR);
	        }).done(function (data) {
	          var msg;
	          if (data && data.status === 'ok') {
	            msg = MSG_SUBMIT_OK;
	          } else if (data && data.message) {
	            msg = data.message;
	          } else {
	            msg = MSG_SUBMIT_ERROR;
	          }
	          $msgSubmit.text(msg);
	          grecaptcha.reset();
	        });
	      }
	      return false;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      this.$form.find(".nombre").empty();
	      this.$form.find(".tu_email").empty();
	      this.$form.find(".su_email").empty();
	      this.$form.find(".captcha").empty();
	      //this.$form.find('#tu_nombre').val('');
	      //this.$form.find('#tu_email').val('');
	      this.$form.find('#su_email').val('');
	      this.sended = false;
	    }
	  }, {
	    key: 'bind',
	    value: function bind() {
	      var _this = this;
	
	      this.$form.on('submit', function () {
	        return _this.handleOnsubmit();
	      });
	      this.$button.on('click', function () {
	        return _this.handleOnsubmit();
	      });
	      this.$form.find('.icono.cerrar').on('click', function () {
	        _this.clean();
	        _this.$form.hide();
	      });
	
	      var app = Voonto.getInstance();
	      app.load('https://www.google.com/recaptcha/api.js');
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.$form.toggle();
	    }
	  }]);
	
	  return Sharemail;
	}();
	
	exports.default = Sharemail;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareMeta = shareMeta;
	exports.shareMetaPortada = shareMetaPortada;
	/* globals voc_tc, voc_tcnew, voc_site */
	var $ = Voonto.$;
	function addNs(ogurl, ns_source) {
	  var ns_linkname = typeof window.voc_tcnew !== 'undefined' && window.voc_tcnew ? window.voc_tcnew : window.voc_tc;
	  return ogurl + '#ns_campaign=rrss-inducido&ns_mchannel=' + window.voc_site + '&ns_source=' + ns_source + '&ns_linkname=' + ns_linkname + '&ns_fee=0';
	}
	
	function shareFacebook(target, ogurl) {
	  $(target).on('click', function () {
	    var url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(addNs(ogurl, 'fb'));
	    window.open(url, "", "toolbar=0, status=0, width=900, height=500");
	  });
	}
	
	function shareTwitter(target, twurl, twtitle, twvia) {
	  $(target).on('click', function () {
	    var url = "https://twitter.com/intent/tweet" + "?url=" + encodeURIComponent(addNs(twurl, 'tw'));
	    if (twtitle) {
	      url = url + "&text=" + encodeURIComponent(twtitle);
	    }
	    if (twvia) {
	      url = url + "&via=" + encodeURIComponent(twvia);
	    }
	    window.open(url, "", "toolbar=0, status=0,width=650, height=360");
	  });
	}
	
	function shareGooglePlus(target, ogurl) {
	  $(target).on('click', function () {
	    var url = "https://plus.google.com/share?url=" + encodeURIComponent(addNs(ogurl, 'gp'));
	    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
	  });
	}
	
	function shareWhatsapp(target, ogurl, ogtitle) {
	  var url = 'whatsapp://send?text=' + encodeURIComponent(ogtitle) + ' ' + encodeURIComponent(addNs(ogurl, 'wh'));
	  var $target = $(target);
	  if ($target.prop('tagName') === 'A') {
	    $target.attr('href', url);
	  } else {
	    $target.on('click', function () {
	      window.location.assign(url);
	    });
	  }
	}
	
	function sharePinterest(target, ogurl, ogtitle, ogimage) {
	  $(target).on('click', function () {
	    var url = "https://pinterest.com/pin/create/bookmarklet/" + "?url=" + encodeURIComponent(addNs(ogurl, 'pn'));
	    if (ogimage) {
	      url = url + "&media=" + encodeURIComponent(ogimage);
	    }
	    if (ogtitle) {
	      url = url + "&description=" + encodeURIComponent(ogtitle);
	    }
	    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
	  });
	}
	
	function shareLinkedin(target, ogurl) {
	  $(target).on('click', function () {
	    var url = "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(addNs(ogurl, 'lk'));
	    window.open(url, "", "toolbar=0, status=0,width=900, height=500");
	  });
	}
	
	function shareMeta() {
	  var ogurl = $("meta[property='og:url']").attr("content");
	  if (ogurl) {
	    var ogtitle = $("meta[property='og:title']").attr("content");
	    var ogimage = $("meta[property='og:image']").attr("content");
	    var twvia = $("meta[name='twitter:site']").attr("content").replace(/^ *@/, '');
	    Logger.info('share links', { ogurl: ogurl, ogtitle: ogtitle, ogimage: ogimage, twvia: twvia });
	
	    shareFacebook('.voc-share-fb', ogurl);
	    shareTwitter('.voc-share-tw', ogurl, ogtitle, twvia);
	    shareGooglePlus('.voc-share-gp', ogurl);
	    sharePinterest('.voc-share-pi', ogurl, ogtitle, ogimage);
	    shareLinkedin('.voc-share-ln', ogurl);
	    shareWhatsapp('.voc-share-wa', ogurl, ogtitle);
	  }
	}
	
	function shareMetaPortada() {
	  $('.redes-sociales-portada').each(function () {
	    var $data = $(this);
	    var ogurl = $data.data("url");
	    var ogtitle = $data.data("title");
	    var twvia = 'abc_es';
	    if (ogurl) {
	      shareFacebook($data.find('.facebook'), ogurl);
	      shareTwitter($data.find('.twitter'), ogurl, ogtitle, twvia);
	      shareWhatsapp($data.find('a.whatsapp'), ogurl, ogtitle);
	    }
	  });
	}
	
	/*
	 export function shareEmbed() {
	 $('.voc-share-home').each(function () {
	 let $data = $(this);
	 let ogurl = $data.data("url");
	 if (ogurl) {
	 let ogtitle = $data.data("title");
	 let twvia = $("meta[name='twitter:site']").attr("content").replace(/ @|@/, '');
	 Logger.info('share links', {ogurl, ogtitle, ogimage, twvia});

	 shareFacebook($data.find('.facebook'), ogurl);
	 shareTwitter($data.find('.twitter'), ogurl, ogtitle, twvia);
	 shareWhatsapp($data.find('a.whatsapp'), ogurl, ogtitle);
	 }
	 });
	 }

	 export default {
	 'shareMeta': shareMeta,
	 'shareEmbed': shareEmbed
	 };
	 */

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* globals vocento */
	var app = Voonto.getInstance();
	var SEL_WIDGET_COLLAPSE = '#commentsBlock';
	var CLASS_COLLAPSE = 'collapse';
	var EVENT_RECALC_STICKY = 'layout:recalc-sticky';
	var REJECT_TIMEOUT = 20000;
	
	//** Start Gigya Comments Widget *
	
	function isCommentsLocation() {
	    var rst = false;
	    var hashParams = document.location.hash.slice(1).split('&');
	    for (var i = 0, n = hashParams.length; i < n; i++) {
	        if (hashParams[i] === 'disqus_thread') {
	            rst = true;
	            break;
	        }
	    }
	    return rst;
	}
	
	function expandWidget($commentTitle, $commentWidget, commentsBlock) {
	    var expanded = $commentTitle.attr('aria-expanded') === 'true';
	    if (!expanded) {
	        Logger.debug('[comments] expand comments');
	        commentsBlock.then(function ($commentsBlock) {
	            $commentsBlock.removeClass(CLASS_COLLAPSE);
	            app.trigger(EVENT_RECALC_STICKY);
	        });
	        $commentTitle.attr('aria-expanded', 'true');
	        // inview don't work in firefox. Trigger comments  widget load.
	        $commentWidget.trigger('inview');
	    }
	}
	
	function toogleWidget($commentTitle, $commentWidget, commentsBlock) {
	    var expanded = $commentTitle.attr('aria-expanded') === 'true';
	    if (expanded) {
	        commentsBlock.then(function ($commentsBlock) {
	            $commentsBlock.addClass(CLASS_COLLAPSE);
	            app.trigger(EVENT_RECALC_STICKY);
	        });
	        // inview don't work in firefox. Trigger comments  widget load.
	    } else {
	        commentsBlock.then(function ($commentsBlock) {
	            $commentsBlock.removeClass(CLASS_COLLAPSE);
	            app.trigger(EVENT_RECALC_STICKY);
	        });
	    }
	    $commentTitle.attr('aria-expanded', expanded ? 'false' : 'true');
	    $commentWidget.trigger('inview');
	}
	
	function commentsInit() {
	    Logger.debug('[comments] commentsInit()');
	
	    var commentsPath = app.lookup('vocento.config.nibara').commentsPath;
	    if (commentsPath === undefined) {
	        throw 'commentsPath path in config is empty';
	    }
	
	    var gigyaReady = new Voonto.RSVP.Promise(function (resolve, reject) {
	        app.when('vocuser:gigyaready').then(function () {
	            resolve(gigya);
	        });
	        setTimeout(function () {
	            reject('timeout');
	        }, REJECT_TIMEOUT);
	    });
	
	    var gigyaUx = new Voonto.RSVP.Promise(function (resolve, reject) {
	        app.when('vocuser:ready').then(function (gigyaUX) {
	            resolve(gigyaUX);
	        });
	        setTimeout(function () {
	            reject('timeout');
	        }, REJECT_TIMEOUT);
	    });
	
	    var commentBlock = new Voonto.RSVP.Promise(function (resolve, reject) {
	        app.one('vocuser:comments:load', function () {
	            resolve(Voonto.$('#commentsBlock'));
	            app.trigger(EVENT_RECALC_STICKY);
	        });
	    });
	
	    var $commentCount = Voonto.$('.icono-comentarios');
	    var $commentTitle = Voonto.$('.voc-comments-title.collapsed');
	    var $commentWidget = Voonto.$('[data-voc-comments]');
	
	    if (isCommentsLocation()) {
	        Logger.debug('[comments] comments hash');
	        expandWidget($commentTitle, $commentWidget, commentBlock);
	    }
	
	    $commentCount.on('click', function () {
	        Logger.debug('[comments] click toolbar icon', this);
	        expandWidget($commentTitle, $commentWidget, commentBlock);
	    });
	
	    $commentTitle.on('click', function () {
	        Logger.debug('[comments] toogle comments', this);
	        toogleWidget($commentTitle, $commentWidget, commentBlock);
	    });
	
	    app.one('vocuser:comments:error', function () {
	        Logger.warning('[comments] comments widget error');
	    });
	
	    gigyaUx.then(function (gigyaUX) {
	        if ('anonimo' === gigyaUX.getUserType()) {
	            $('<style>.gigya-logged-in{display:none !important;}</style>').appendTo(document.head);
	        } else {
	            $('<style>.gigya-logged-out{display:none !important;}</style>').appendTo(document.head);
	        }
	    }).catch(function (error) {
	        Logger.warning('[comments] gigyaUx error: ' + error);
	    });
	
	    gigyaReady.then('vocuser:gigyaready').then(function () {
	        app.load(commentsPath + '/comments.js');
	    }).catch(function (error) {
	        Logger.warning('[comments] gigya error: ' + error);
	    });
	}
	
	//** End Gigya Comments Widget
	
	exports.default = commentsInit;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* globals vocento, noticiaid */
	var app = Voonto.getInstance();
	
	var TeInteresa = function () {
		function TeInteresa(form) {
			_classCallCheck(this, TeInteresa);
	
			this.libPath = app.lookup('vocento.config.nibara').libPath;
			if (this.libPath === undefined) {
				throw 'nibara libPath config is empty';
			}
			this.isMobile = Voonto.is.mobile();
			this.isTablet = Voonto.is.tablet();
		}
	
		_createClass(TeInteresa, [{
			key: 'load',
			value: function load($container) {
				var _this = this;
	
				var comscore = app.lookup('vocento.tracking.comscore');
				var tc = comscore.voc_tcnew ? comscore.voc_tc : null;
				var se = comscore.voc_se;
				if (typeof noticiaid === 'undefined' || !noticiaid || !tc || !se) {
					Logger.error('No se puede cargar te-interesa');
					return false;
				}
	
				var url = "/ajax/v2/te-interesa.html?recid=" + noticiaid + "&voc_tc=" + tc + "&voc_se=" + se;
				Voonto.$.ajax({
					"type": "get",
					"url": url,
					"timeout": 20000
				}).fail(function () {
					Logger.error('No se puede cargar te-interesa');
					_this.mobileShowToolbar();
				}).done(function (html) {
					if (html) {
						_this.mobileHideToolbar();
	
						$container.html(html);
						_this.swiper($container.find('.swiper-container'));
	
						_this.mobileEvents($container);
					} else {
						_this.mobileShowToolbar();
					}
				});
			}
		}, {
			key: 'mobileShowToolbar',
			value: function mobileShowToolbar() {
				if (this.isMobile && Voonto.SocialToolbar) {
					Voonto.SocialToolbar.enable();
				}
			}
		}, {
			key: 'mobileHideToolbar',
			value: function mobileHideToolbar() {
				if (this.isMobile && Voonto.SocialToolbar) {
					Voonto.SocialToolbar.disable();
				}
			}
		}, {
			key: 'mobileEvents',
			value: function mobileEvents($container) {
				var _this2 = this;
	
				if (this.isMobile) {
					this.mobileHideToolbar();
					$container.find('.cerrar').click(function () {
						$container.hide();
						_this2.mobileShowToolbar();
					});
	
					Voonto.$('.noticia').click(function () {
						Logger.info('[Breaking News] click Te-Interesa');
						var type = Voonto.$(this).data('type');
	
						Logger.info('[Breaking News] type: ', type);
						Logger.info('[Breaking News] href: ', Voonto.$(this).data('href'));
	
						window.location.href = Voonto.$(this).data('href');
					});
				}
			}
		}, {
			key: 'swiper',
			value: function swiper($elm) {
				var _this3 = this;
	
				Logger.info('Te-Interesa: Cargado JQuery-UI');
				$elm.find('.swiper-prev-row-bn').css('zIndex', 99);
				$elm.find('.swiper-next-row-bn').css('zIndex', 99);
				$elm.find('.swiper-wrapper').attr('style', 'min-height: 1px !important;');
	
				var numElem = 0;
				$elm.find("[id^='j-swiper-slide-']").each(function () {
					numElem++;
				});
				Logger.info('Te-Interesa: Número elementos: ' + numElem);
	
				var IntID = this.setTimer(numElem, $elm);
	
				$elm.find('.swiper-prev-row-bn').on('click', function () {
					Logger.info('Te-Interesa: Noticia anterior');
					clearInterval(IntID);
					IntID = _this3.setTimer(numElem, $elm);
					_this3.changeSlide('anterior', numElem, $elm);
				});
	
				$elm.find('.swiper-next-row-bn').on('click', function () {
					Logger.info('Te-Interesa: Noticia siguiente');
					clearInterval(IntID);
					IntID = _this3.setTimer(numElem, $elm);
					_this3.changeSlide('siguiente', numElem, $elm);
				});
			}
		}, {
			key: 'setTimer',
			value: function setTimer(numElem, $elm) {
				var _this4 = this;
	
				var i = setInterval(function () {
					Logger.info('Te-Interesa: setInterval - Noticia siguiente');
					_this4.changeSlide('interval', numElem, $elm);
				}, 7000); // 7000ms = 7 segartSlider, 4000);
				return i;
			}
		}, {
			key: 'changeSlide',
			value: function changeSlide(action, numElem, $elm) {
				var id = Voonto.$("[id^='j-swiper-slide-']:visible").data('pos');
				Logger.info('Te-Interesa: ID Visible: ' + id);
	
				var newId = id - 1;
				if (action === 'anterior') {
					if (id <= 1) {
						return false;
					}
				} else {
					newId = id + 1;
					if (action === 'interval') {
						if (id === numElem) {
							newId = 1;
							id = 1;
						}
					}
	
					if (id >= numElem) {
						return false;
					}
				}
	
				$elm.find("[id^='j-swiper-slide-']").each(function (i, e) {
					if (newId === Voonto.$(e).data('pos')) {
						Voonto.$(e).show();
					} else {
						Voonto.$(e).hide();
					}
				});
			}
		}]);
	
		return TeInteresa;
	}();
	
	exports.default = TeInteresa;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// article-script.js